import { bulk as bulkUpdateEvents } from './update';
import { bulk as bulkUpdateMarkets } from '../../markets/actions/update';
import { bulk as bulkUpdateCompetitions } from '../../competitions/actions/update';
import { bulk as bulkUpdateParticipants } from '../../participants/actions/update';
import { bulk as bulkUpdateSelections } from '../../selections/actions/update';
import { bulk as bulkUpdateSports } from '../../sports/actions/update';
import { update as updateTags } from '../../tags/actions/update';
import { subscribe as subscribeEvent } from './subscribe';

import { update } from './update';

export function request(id) {
    return {
        type: 'EVENT_REQUEST',
        id
    };
}

export function error(id, errors) {
    return {
        type: 'EVENT_ERROR',
        id,
        errors
    };
}

export function finish(id, { events, markets, competitions, participants, selections, sports, tags }) {
    return (dispatch) => {
        dispatch(bulkUpdateSports(sports));
        dispatch(bulkUpdateEvents(events, competitions));
        dispatch(bulkUpdateMarkets(markets));
        dispatch(bulkUpdateCompetitions(competitions));
        dispatch(bulkUpdateParticipants(participants));
        dispatch(bulkUpdateSelections(selections));
        dispatch(updateTags(id, tags));
        dispatch(subscribeEvent(id));

        dispatch({
            type: 'EVENT_FINISH',
            id
        });
    };
}
